import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Reports — a menu, which is all the old page is.
 *
 * All four are rebuilt now (`pages/Report.js`, one spec each), so every card
 * routes inside the tree. The two Sales reports keep their descriptions: the
 * split at 1 July 2024 is the only thing that tells you which one to open, and
 * dropping it would make this page unusable in the way that matters.
 *
 * No card is added and none invented. A "revenue this month" tile is what the
 * Home design wants and what nothing here can answer — see REWRITE-STATE.md.
 */

/**
 * Exported so the command palette can offer the same four without restating
 * them. A report the menu knows about and ⌘K does not is a report nobody finds.
 */
export const REPORTS = [
  {
    title: 'Sales report',
    description: 'Sales from 1 July 2024 onwards',
    to: '/next/reports/sales-new'
  },
  {
    title: 'Historical sales report',
    description: 'Sales from before 1 July 2024',
    to: '/next/reports/sales-old'
  },
  {
    title: 'Settlement report',
    description: 'Transactions in a date range',
    to: '/next/reports/settlement'
  },
  {
    title: 'Seasonal court report',
    description: 'One calendar month of seasonal court activity',
    to: '/next/reports/seasonal-courts'
  }
];

export default function Reports() {
  return (
    <div className="next-page next-page--wide">
      <header className="next-page__header">
        <h1>Reports</h1>
        <p className="next-muted">Each one asks for its parameters and downloads a CSV.</p>
      </header>

      <div className="next-cards">
        {REPORTS.map(({ title, description, to }) => (
          <Link className="next-cards__card" key={to} to={to}>
            <h2>{title}</h2>
            {description && <p className="next-muted">{description}</p>}
            <span className="next-cards__go" aria-hidden>→</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

Reports.requiresLogin = true;
